<template>
  <Modal
    :id="'cmp-licence-licence-advanced_search'"
    :loading="loading"
    @cancelled="onCancel"
  >
    <template slot="header">{{
      $dft.snakeCaseToWords("add_licence")
    }}</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <TextField
            :id="'licence_name'"
            class="m1"
            required
            v-bind="textFieldConfig"
            :showValidationIcons="true"
            :immediateValidation="true"
            v-model="dataForm.licence_name"
            isModel
            :placeholder="$t('licence_name')"
            @valuechanged="onTextFieldValueChange"
         
          />

          <TextField
            :id="'licence_usage'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="dataForm.licence_usage"
            isModel
            :placeholder="$t('Licence Usage')"
            @valuechanged="onTextFieldValueChange"
          />
          <Dropdown
            :id="'label_status_id'"
            class="m2"
            required
            :options="licenceTypesTV"
            :selected="
              licenceTypesTV.find(
                (x) => x.value == dataForm.label_status_id
              )
            "
            :placeholder="$t('licence_type')"
            :showValidationIcons="true"
            :immediateValidation="true"
             @validated="e => onValidation('label_status_id', e)"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('label_status_id', e)"
          ></Dropdown>


          <Dropdown
            :id="'exclusivity'"
            class="m2"
            :options="exclusivityTV || []"
            :selected="
              exclusivityTV.find((t) => t.value == dataForm.exclusivity)
            "
            :placeholder="$t('exclusivity')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('exclusivity', e)"
            :listHeight="250"
          ></Dropdown>

          <Dropdown
            :id="'territory_id'"
            class="m2"
            :options="territoryIdTV"
            :selected="
              territoryIdTV.find((x) => x.value == dataForm.territory_id)
            "
            :placeholder="$t('territory')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('territory_id', e)"
          ></Dropdown>

          <Dropdown
            :id="'currency_id'"
            class="m2"
            :options="currencyIdTV"
            :selected="
              currencyIdTV.find((x) => x.value == dataForm.currency_id)
            "
            :placeholder="$t('currency')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('currency_id', e)"
          ></Dropdown>

          <TextField
              
            type="date"
            :id="'date_start'"
            class="m1"
            :placeholder="$t('start_date')"
            :value="dataForm.date_start"
            :showImmediate="true"
            autocomplete="off"
            @valuechanged="onDateChange"
          />
          <div style="max-width:277px" class="ut-flex">
            <TextField
              style="min-width:140px"
              :id="'term_years'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="dataForm.term_years"
              isModel
              :placeholder="$t('Years')"
              @valuechanged="onTextFieldValueChange"
            />
          
            <TextField
              style="margin-left:14px !important;min-width:140px"
              :id="'term_month'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="dataForm.term_month"
              isModel
              :placeholder="$t('month')"
              @valuechanged="onTextFieldValueChange"
            />
          </div>



          <Dropdown
            :id="'accounting_period'"
            class="m2"
            :options="accountingPeriodsTV"
            :selected="
              accountingPeriodsTV.find((x) => x.value == dataForm.accounting_period)
            "
            :placeholder="$t('Accounting Period')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('accounting_period', e)"
          ></Dropdown>
          <TextField
            :id="'due_days'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="dataForm.due_days"
            isModel
            :placeholder="$t('due_days')"
            @valuechanged="onTextFieldValueChange"
          />
          <DTCheckbox
            :id="'active_flag'"
            :label="'active'"
            :checked="dataForm.active_flag==1"
            @click="onIsActiveClick"
            :minH="'42px'"
            :class="'ml0'"
          />
          
       

      

          
        </div>
      </div>
    </template>

    <template slot="options">
   
      <button class="dt-button s6" @click.stop="onCancel">Close</button>
      <button
        class="dt-button v1 s6"
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click.stop="onOKClicked"

      >
        OK
      </button>
    </template>
  </Modal>
</template>

<script>

import Modal from "@dtplugins/modal/modal";
import TextField from "@plugins/text-field/text-field";
import { EventHooks } from "../../../../plugins/text-field";

import { async } from "rxjs/internal/scheduler/async";

import { createTV } from "../../../../models/text-value.model";
import { addRemoveSet, subscribeSubject } from "../../../../utility";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import { Subject } from "rxjs";
import { licenceService } from '../../services/licence.service';



export default {
  components: {
    Modal,
    TextField,
  },
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        isModel: true,
      },
      dataForm:{
        licence_name: "",
        licence_usage:"",
        exclusivity:"",
        territory_id: "",
        label_status_id: "",
        currency_id: "",
        term_month:"",
        term_years:"",
        due_days:"",
        date_start: "",
        accounting_period:"",
        active_flag:0,
      },

      territories:[],
      currencies:[],
      licenceType:[],
      licenceStatuses:[],
      validationResult: {},

      loading: false,
    };
  },
  mounted:async function() {
 
    
   const resData= await licenceService.createLcncForm(this.$route.query.licence_account_id);

    console.log("RESDATA",resData); 
    this.territories=resData.data.territories;
    this.currencies=resData.data.currencies;
    this.licenceType=resData.data.license_types;

    this.licenceStatuses=resData.data.licence_statuses;
   
  },
  computed: {
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    // return ""
    },
    licenceTypesTV:function(){
      
      return createTV(this.licenceStatuses,'label_status_name','label_status_id');
      // return[
      //     {text:"compilation",value:"compilation"},
      //     {text:"exclusive licence",value:"exclusive_licence"},
      //     {text:"sync movie",value:"sync_movie"},
      //     {text:"sync advertisement",value:"sync_advertisement"},
      //     {text:"promotion",value:"promotion"},
      //     {text:"covermount CD",value:"covermount_cd"},
      //   ]
    },
    territoryIdTV:function(){
        return createTV(this.territories,"territory_name","territory_id");
    },
    currencyIdTV:function(){
        return createTV(this.currencies,"currency_iso","currency_id");
    }, 
    exclusivityTV: function(){
  
      return[
          {text:"exclusive",value:"exclusive"},
          {text:"non exclusive",value:"non_exclusive"}
        ]
        
    },
    accountingPeriodsTV :function(){
  
      return[
          {text:"flat fee",value:"flat_fee"},
          {text:"bi annually",value:"bi_annually"},
          {text:"monthly",value:"monthly"},
          {text:"quarterly",value:"quarterly"},
        ]
    },

  },
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult,name, value);
    },
    onDateChange: function (name, value) {
      this.dataForm[name] = value;
    },
    onTextFieldValueChange: function (name, value) {
      console.log(name,value)
      this.dataForm[name] = value;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function (name, value) {
      this.dataForm[name] = value.value;
    },
 
    onCheckboxChange: function (name, event) {
      this.dataForm[name] = event.target.checked;
    },
    onOKClicked:function(){
        const payload={ ...this.dataForm ,licence_account_id:this.$route.query.licence_account_id};
        this.$emit("create",payload)
        this.onCancel();
    },

    onIsActiveClick: function (event) {
      console.log( event.target.checked);
      if(event.target.checked){
        this.dataForm.active_flag=1
      }else{
        this.dataForm.active_flag=0
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.cmp-licence-licence-advanced_search {
  .body-container {
    //max-height: 470px;
    padding-right: 25px;
    overflow: hidden;
    overflow-y: auto;

    .dropdown,
    .dt-input-box--container,
    .date-control {
      max-width: 320px;
    }
  }
  .omit-toggler {
    display: flex;
    cursor: pointer;

    &.missed {
      color: var(--c-error);
    }

    .omit-toggler--label {
      margin: auto 0px auto 4px;
      cursor: pointer;
    }
  }

  .search--input {
    flex: 1;
  }

  .search--checkbox {
    min-width: 20px;
    margin-left: 4px;

    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (min-width: 320px) and (max-width: 480px) {
      padding-left: 0px;
      margin-left: 0px;

      .checkmark {
        margin-left: 10px;
      }
    }
  }

  .checkbox-container {
    .dt-checkbox-control {
      align-items: center;
      .dt-checkbox-label {
        flex: 1;
        padding-left: 10px;
      }
    }
  }

  .row-control {
    margin: 10px 0;
    .search--input {
      max-width: 100%;
    }
  }
  .date-control {
    .dt-input-box--container {
      flex: 1;
      &:first-child {
        padding-right: 10px;
      }
      &:last-child {
        padding-left: 10px;
      }
    }
  }
}
</style>